import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            实时同步最新韩漫更新动态
          </p>
        </div>
        <Link
          to="/category/dongzuo"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {latestComics.map((comic) => (
          <ComicCard key={comic.id} {...comic} />
        ))}
      </div>
    </section>
  );
}